import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersStateContext } from './state/users/users-state-manager.context';
import { ItinerariesStateContext } from './state/itineraries/itineraries-state-manager.context';
import { LocationsStateContext } from './state/locations/locations-state-manager.context';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LcuMapModule } from '@lowcodeunit/lcu-map-common';
import { AuthService } from './services/auth.service';
import { MaterialModule } from '@lcu/common';
import { MapService } from './services/map.service';
import { SubString } from './utils/pipes/subString.pipe';

@NgModule({
  declarations: [SubString],
  imports: [
    CommonModule,
    DragDropModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    MaterialModule,
    ReactiveFormsModule,
    RouterModule,
    LcuMapModule
  ],
  providers: [AuthService],
  exports: [FlexLayoutModule, MaterialModule, ReactiveFormsModule, LcuMapModule, SubString],
  entryComponents: []
})
export class LcuAmblOnModule {
  static forRoot(): ModuleWithProviders<LcuAmblOnModule> {
    return {
      ngModule: LcuAmblOnModule,
      providers: [
        UsersStateContext,
        ItinerariesStateContext,
        LocationsStateContext,
        MapService]
    };
  }
}
